import {Component, model, OnInit} from '@angular/core';
import {ArbitraryRoundDto, SrmHospitalArbitrarySearchParam} from "../../../../../../generated-model/model";
import {monthNames} from "../../../../../app.constants";
import {ControlContainer, FormsModule, NgForm} from "@angular/forms";
import {NgForOf} from "@angular/common";

export type ArbitraryRoundDtoExtension = ArbitraryRoundDto & { name: string, showTime: Date }

export const arbitraryRoundDtoComparator =
  (a: ArbitraryRoundDto, b: ArbitraryRoundDto) => (a?.roundNumber === b?.roundNumber && a?.yearNumber === b?.yearNumber && a?.monthNumber === b?.monthNumber)

export const startArbitraryYear = 2019

@Component({
  selector: 'app-arbitrary-round',
  templateUrl: './arbitrary-round.component.html',
  styleUrls: ['./arbitrary-round.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    NgForOf
  ],
  viewProviders: [{
    provide: ControlContainer,
    useExisting: NgForm
  }]
})
export class ArbitraryRoundComponent implements OnInit {

  comparator = arbitraryRoundDtoComparator
  params = model.required<SrmHospitalArbitrarySearchParam>();

  roundDtos: ArbitraryRoundDtoExtension[] = [];
  years: number[] = []

  currentDate = new Date();

  constructor() {
  }

  ngOnInit(): void {
    this.params().budgetYear = this.currentDate.getFullYear();
    /**
     * ปีงบประมาณ จะเปลี่ยนปีงบเมื่อเดือนตุลาคมวันที่ 16 ขึ้นไป
     */
    if ((this.currentDate.getMonth() === 9 && this.currentDate.getDate() > 15) || this.currentDate.getMonth() >= 10) {
      this.params().budgetYear += 1;
    }

    /**
     * yearNumber คือปีปฏิทิน
     * this.currentDate.getDate() <= 15 && this.currentDate.getMonth() === 0 หมายถึงเดือนมกราคม ถ้ายังไม่ถึงวันที่ 16 จะใช้ปี - 1
     *
     * roundNumber คือรอบวันที่ 15 ขึ้นไปคือรอบที่ 2
     *
     * monthNumber เดือนถ้าวันที่มากกว่า 15 คือเดือนปัจจุบัน
     * ถ้าไม่ใช่คือเดือนก่อนหน้า แต่ถ้าเดือนก่อนหน้ามีค่า 0 fix เป็น 12 คือเดือนธันวาคม
     */
    this.params()['roundDto'] = {
      yearNumber:
        this.currentDate.getDate() <= 15 && this.currentDate.getMonth() === 0
          ? this.currentDate.getFullYear() - 1
          : this.currentDate.getFullYear(),
      roundNumber: this.currentDate.getDate() > 15 ? 1 : 2,
      monthNumber:
        this.currentDate.getDate() > 15 ? this.currentDate.getMonth() + 1 : this.currentDate.getMonth() === 0 ? 12 : this.currentDate.getMonth(),
    };
    this.selectRound();

    for (let i = startArbitraryYear; i <= this.params().budgetYear; i++) {
      this.years.push(i);
    }

    this.prepareData()
  }

  selectRound() {
    this.params().round = this.params()['roundDto']?.roundNumber
    this.params().month = this.params()['roundDto']?.monthNumber
    this.params().year = this.params()['roundDto']?.yearNumber
  }

  selectYear() {

    this.params()['roundDto'] = undefined
    this.params().round = undefined
    this.params().month = undefined
    this.params().year = undefined
    this.prepareData()
  }

  /**
   * showTime หมายถึงวันที่ที่จะให้แสดงรอบประมาลผลนี้
   */
  prepareData() {
    let year = this.params().budgetYear
    this.roundDtos = [
      {showTime: new Date(`${year}-10-01`), roundNumber: 2, monthNumber: 9, yearNumber: year, name: `รอบที่ 2 - ${monthNames[8].name} ${+year + 543}`},
      {showTime: new Date(`${year}-09-16`), roundNumber: 1, monthNumber: 9, yearNumber: year, name: `รอบที่ 1 - ${monthNames[8].name} ${+year + 543}`},
      {showTime: new Date(`${year}-09-01`), roundNumber: 2, monthNumber: 8, yearNumber: year, name: `รอบที่ 2 - ${monthNames[7].name} ${+year + 543}`},
      {showTime: new Date(`${year}-08-16`), roundNumber: 1, monthNumber: 8, yearNumber: year, name: `รอบที่ 1 - ${monthNames[7].name} ${+year + 543}`},
      {showTime: new Date(`${year}-08-01`), roundNumber: 2, monthNumber: 7, yearNumber: year, name: `รอบที่ 2 - ${monthNames[6].name} ${+year + 543}`},
      {showTime: new Date(`${year}-07-16`), roundNumber: 1, monthNumber: 7, yearNumber: year, name: `รอบที่ 1 - ${monthNames[6].name} ${+year + 543}`},
      {showTime: new Date(`${year}-07-01`), roundNumber: 2, monthNumber: 6, yearNumber: year, name: `รอบที่ 2 - ${monthNames[5].name} ${+year + 543}`},
      {showTime: new Date(`${year}-06-16`), roundNumber: 1, monthNumber: 6, yearNumber: year, name: `รอบที่ 1 - ${monthNames[5].name} ${+year + 543}`},
      {showTime: new Date(`${year}-06-01`), roundNumber: 2, monthNumber: 5, yearNumber: year, name: `รอบที่ 2 - ${monthNames[4].name} ${+year + 543}`},
      {showTime: new Date(`${year}-05-16`), roundNumber: 1, monthNumber: 5, yearNumber: year, name: `รอบที่ 1 - ${monthNames[4].name} ${+year + 543}`},
      {showTime: new Date(`${year}-05-01`), roundNumber: 2, monthNumber: 4, yearNumber: year, name: `รอบที่ 2 - ${monthNames[3].name} ${+year + 543}`},
      {showTime: new Date(`${year}-04-16`), roundNumber: 1, monthNumber: 4, yearNumber: year, name: `รอบที่ 1 - ${monthNames[3].name} ${+year + 543}`},
      {showTime: new Date(`${year}-04-01`), roundNumber: 2, monthNumber: 3, yearNumber: year, name: `รอบที่ 2 - ${monthNames[2].name} ${+year + 543}`},
      {showTime: new Date(`${year}-03-16`), roundNumber: 1, monthNumber: 3, yearNumber: year, name: `รอบที่ 1 - ${monthNames[2].name} ${+year + 543}`},
      {showTime: new Date(`${year}-03-01`), roundNumber: 2, monthNumber: 2, yearNumber: year, name: `รอบที่ 2 - ${monthNames[1].name} ${+year + 543}`},
      {showTime: new Date(`${year}-02-16`), roundNumber: 1, monthNumber: 2, yearNumber: year, name: `รอบที่ 1 - ${monthNames[1].name} ${+year + 543}`},
      {showTime: new Date(`${year}-02-01`), roundNumber: 2, monthNumber: 1, yearNumber: year, name: `รอบที่ 2 - ${monthNames[0].name} ${+year + 543}`},
      {showTime: new Date(`${year}-01-16`), roundNumber: 1, monthNumber: 1, yearNumber: year, name: `รอบที่ 1 - ${monthNames[0].name} ${+year + 543}`},

      {showTime: new Date(`${year}-01-01`), roundNumber: 2, monthNumber: 12, yearNumber: (year - 1), name: `รอบที่ 2 - ${monthNames[11].name} ${(year - 1) + 543}`},
      {showTime: new Date(`${year - 1}-12-16`), roundNumber: 1, monthNumber: 12, yearNumber: (year - 1), name: `รอบที่ 1 - ${monthNames[11].name} ${(year - 1) + 543}`},
      {showTime: new Date(`${year - 1}-12-01`), roundNumber: 2, monthNumber: 11, yearNumber: (year - 1), name: `รอบที่ 2 - ${monthNames[10].name} ${(year - 1) + 543}`},
      {showTime: new Date(`${year - 1}-11-16`), roundNumber: 1, monthNumber: 11, yearNumber: (year - 1), name: `รอบที่ 1 - ${monthNames[10].name} ${(year - 1) + 543}`},
      {showTime: new Date(`${year - 1}-11-01`), roundNumber: 2, monthNumber: 10, yearNumber: (year - 1), name: `รอบที่ 2 - ${monthNames[9].name} ${(year - 1) + 543}`},
      {showTime: new Date(`${year - 1}-10-16`), roundNumber: 1, monthNumber: 10, yearNumber: (year - 1), name: `รอบที่ 1 - ${monthNames[9].name} ${(year - 1) + 543}`},
    ]
    this.roundDtos = this.roundDtos.filter(f => f.showTime <= this.currentDate)
  }
}
